import React from "react";

import Editor from './EditorArticle'
import EditorWrapper from '../../EditorWrapper'

import Top from "../../common/TextOnPicture";
import EmptyArticle from "../../common/EmptyArticle";

const ATextOnPicture = props => {
  var article = EmptyArticle();
  const settings = props.settings;
  const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

  article.title = settings.title_normal;
  article.picture.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
  article.url = settings.link;
  article.partner = settings.partner;
  article.label = settings.label;
  article.player = settings.player;
  article.stats = (settings.stats ? settings.stats : { shares: '0', comments: '0' });

  // linki dodatkowe
  settings.show_links = (settings.show_links ? settings.show_links : 'off');
  article.show_links = settings.show_links;
  article.links = settings.links;

  // partner
  settings.show_partner_logo = true;
  article.partner_logo = settings.partner_logo;

  if (settings.embed) {
    article.embed = settings.embed
  }

  // props.onRegisterBox(props.blockId, props.id, 'title_normal')

  return (
    <div className={props.classes} {...props.events} >
      <EditorWrapper {...props} editor={Editor} />
      <Top
        article={article}
        size={props.size}
        imageHeight={props.imageHeight}
        preserveImageRatio={props.preserveImageRatio}
        aspectRatio={props.aspectRatio}
        media={settings.media}
      />
    </div>
  );
};

export default ATextOnPicture;
